import React from 'react';
import { CheckIcon, XIcon, ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { afterItems, beforeItems } from '../../data/landing';
export function BeforeAfter() {
  return <section className="bg-cream" data-id="element-96" data-mp="22l13hdb9fdge">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-20" data-id="element-97" data-mp="22lsra1ym86w4">
        <SectionHeading title={<>From guessing <em className="text-coral" data-id="element-99" data-mp="2zai5nib1ahdc">to knowing</em> where to start</>} subtitle="What changes when you have a system ready before the next difficult moment." data-id="element-98" data-mp="2zaryddngr2mq" />

        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr]" data-id="element-100" data-mp="2q9akm1xj3d17">
          <div className="rounded-3xl border-2 border-coral/30 bg-white p-6 sm:p-8" data-id="element-101" data-mp="2lbsa473v4pr3">
            <p className="inline-flex rounded-full bg-coral px-4 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-102" data-mp="1eux27cljnpsk">Before</p>
            <h3 className="mt-4 font-display text-2xl font-bold text-navy" data-id="element-103" data-mp="19vansztzc3i6">Without a system</h3>
            <ul className="mt-5 space-y-4" data-id="element-104" data-mp="176nra6647rbr">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-105" data-mp="1c3e5sp29uev2">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-coral-soft text-coral-dark" data-id="element-106" data-mp="y4y0n2k24wf1">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-107" data-mp="132prdt8yuchn" />
                  </span>
                  <span className="text-[17px] leading-snug text-navy" data-id="element-108" data-mp="odtjbw6wszh1">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-109" data-mp="fe6jvfxqq3qm">
            <span className="grid h-12 w-12 place-items-center rounded-full bg-navy text-white shadow-lg" data-id="element-110" data-mp="fc3ki5ap6y98">
              <ArrowDownIcon className="h-6 w-6 md:hidden" data-id="element-111" data-mp="jdfbof97zrjj" />
              <ArrowRightIcon className="hidden h-6 w-6 md:block" data-id="element-112" data-mp="5hbjssltjva8" />
            </span>
          </div>

          <div className="rounded-3xl border-2 border-teal bg-teal-soft p-6 sm:p-8" data-id="element-113" data-mp="adsc7z01wvt4">
            <p className="inline-flex rounded-full bg-teal px-4 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-114" data-mp="2c5aufh33eyda">After</p>
            <h3 className="mt-4 font-display text-2xl font-bold text-navy" data-id="element-115" data-mp="27bg2jqdc3d34">With Calm Response 5™</h3>
            <ul className="mt-5 space-y-4" data-id="element-116" data-mp="239uwooz7vz2f">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-117" data-mp="1yep9lmu2wecr">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-teal text-white" data-id="element-118" data-mp="2v23ohfk3438o">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-119" data-mp="2r21mt6ecn9te" />
                  </span>
                  <span className="text-[17px] font-bold leading-snug text-navy" data-id="element-120" data-mp="2m0m25fg335bj">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-121" data-mp="1ao333zzq324v">
          <CTAButton label="I want to go from guessing to knowing" data-id="element-122" data-mp="1al75kcrsefgy" />
        </div>
      </div>
    </section>;
}